import some from "lodash/some";
import { createSelector } from "reselect";

const getStory = (state) => state.story;

export default createSelector(getStory, (story) => {
  if (story) {
    return some(story.entities.videos, { is360: true });
  }
  return false;
});
